module.exports = __webpack_public_path__ + "img/usuarios-proveedores.df25002d.svg";